import type { FlagsType } from '@iheartjane/feature-flags';
import type { QueryClient } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';

import { Layout } from '../components';
import { Landing } from '../pages/Landing/Landing';
import { NotFound } from '../pages/NotFound';
import { QrCheckout } from '../pages/QrCheckout/QrCheckout';
import { cartRoutes } from './cartRoutes';
import { menuRoutes } from './menuRoutes';
import { orderCompleteRoute } from './orderCompleteRoutes';

const landingRedirectRoute: RouteObject = {
  children: [
    {
      element: <Navigate to="landing" replace={true} />,
      index: true,
    },
  ],
};
const landingRoute: RouteObject = {
  children: [
    {
      element: <Landing />,
      index: true,
      path: 'landing',
    },
  ],
};

const qrCheckoutRoute: RouteObject = {
  children: [
    {
      element: <QrCheckout />,
      path: 'reservation/qr',
    },
  ],
  element: <Layout isFullScreen />,
};

export const kioskRoutes = (
  queryClient: QueryClient,
  flags: FlagsType
): RouteObject => ({
  children: [
    landingRoute,
    landingRedirectRoute,
    menuRoutes(queryClient, flags),
    cartRoutes(queryClient),
    orderCompleteRoute(),
    qrCheckoutRoute,
    {
      element: <NotFound />,
      path: `*`,
    },
  ],
});
